'use strict';

exports.__esModule = true;
var LOAD_URI = exports.LOAD_URI = 'SPECIALIST_PAGE_ACTIONS:LOAD_URI';
var LOADED_URI = exports.LOADED_URI = 'SPECIALIST_PAGE_ACTIONS:LOADED_URI';

var pageActions = {
    loadUri: function loadUri(errorMessage, errorCode) {
        return {
            type: LOAD_URI,
            payload: {
                errorCode: errorCode,
                errorMessage: errorMessage
            }
        };
    },
    loadedUri: function loadedUri() {
        return {
            type: LOADED_URI,
            payload: {
                loadedUri: true
            }
        };
    }
};

exports.default = pageActions;


// WEBPACK FOOTER //
// ./components/error-page/lib/actions/page-actions.js